import * as actionTypes from "../../Actions/Plan/ActionTypes";
import * as actionReducer from "./ActionReducer";

const initialState = {
  socketIsListeningToPlanningTable: false,

  Plans: {
    request: null,
    response: null,
    error: null,
  },

  cacheDialogValue: {
    addPlan: {},
    option: [],
  },

  DownloadPlan: {
    request: null,
    response: null,
    error: null,
  },

  DownloadExcelPlan: {
    request: null,
    response: null,
    error: null,
  },

  DeletePlan: {
    request: null,
    response: null,
    error: null,
  },

  UpdatePlan: {
    request: null,
    response: null,
    error: null,
  },

  ErrorPlan: {
    request: null,
    response: null,
    error: null,
  },

  NewPlan: {
    request: null,
    response: null,
    error: null,
  },

  PostPlanConfig: {
    request: null,
    response: null,
    error: null,
  },

  AllPlansList: {
    request: null,
    response: null,
    error: null,
  },

  ExecutePlan: {
    request: null,
    response: null,
    error: null,
  },

  restorePlan: {
    error: null,
    request: null,
    response: null,
  },

  RestoreDriver: {
    error: null,
    request: null,
    response: null,
  },

  ExternalPlan: {
    error: null,
    request: null,
    response: null,
  },

  PlanLogs: {
    error: null,
    request: null,
    response: null,
  },

  ToolnameList: {
    error: null,
    request: null,
    response: null,
  },

  MissionInfoById: {
    error: null,
    request: null,
    response: null,
  },

  DownloadPlanForm: {
    error: null,
    request: null,
    response: null,
  },
};

const PlanReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.CLEAR_STATE:
      return actionReducer.clearState(state, action, initialState);

    case actionTypes.CACHE_ADD_PLAN:
      return actionReducer.cacheAddPlan(state, action);

    case actionTypes.TOGGLE_SOCKET_LISTENING_PLANNING:
      return actionReducer.togglesocketIsListeningToPlanningTable(
        state,
        action
      );

    case actionTypes.GET_PLANS:
      return actionReducer.getPlans(state, action);
    case actionTypes.GET_PLANS_SUCCESS:
      return actionReducer.getPlansSuccess(state, action);
    case actionTypes.GET_PLANS_FAIL:
      return actionReducer.getPlansFail(state, action);

    case actionTypes.CREATE_PLAN:
      return actionReducer.createPlan(state, action);
    case actionTypes.CREATE_PLAN_SUCCESS:
      return actionReducer.createPlanSuccess(state, action);
    case actionTypes.CREATE_PLAN_FAIL:
      return actionReducer.createPlanFail(state, action);

    case actionTypes.DOWNLOAD_OPTIMIZE_FILE:
      return actionReducer.downloadOptimizePlan(state, action);
    case actionTypes.DOWNLOAD_OPTIMIZE_FILE_SUCCESS:
      return actionReducer.downloadOptimizePlanSuccess(state, action);
    case actionTypes.DOWNLOAD_OPTIMIZE_FILE_FAIL:
      return actionReducer.downloadOptimizePlanFail(state, action);

    case actionTypes.DOWNLOAD_EXCEL_FILE:
      return actionReducer.downloadExcelPlan(state, action);
    case actionTypes.DOWNLOAD_EXCEL_FILE_SUCCESS:
      return actionReducer.downloadExcelPlanSuccess(state, action);
    case actionTypes.DOWNLOAD_EXCEL_FILE_FAIL:
      return actionReducer.downloadExcelPlanFail(state, action);

    case actionTypes.DELETE_PLAN:
      return actionReducer.deletePlan(state, action);
    case actionTypes.DELETE_PLAN_SUCCESS:
      return actionReducer.deletePlanSuccess(state, action);
    case actionTypes.DELETE_PLAN_FAIL:
      return actionReducer.deletePlanFail(state, action);

    case actionTypes.ERROR_PLAN_MESSAGE:
      return actionReducer.errorPlan(state, action);
    case actionTypes.ERROR_PLAN_MESSAGE_SUCCESS:
      return actionReducer.errorPlanSuccess(state, action);
    case actionTypes.ERROR_PLAN_MESSAGE_FAIL:
      return actionReducer.errorPlanFail(state, action);

    case actionTypes.UPDATE_PLAN:
      return actionReducer.updatePlan(state, action);
    case actionTypes.UPDATE_PLAN_SUCCESS:
      return actionReducer.updatePlanSuccess(state, action);
    case actionTypes.UPDATE_PLAN_FAIL:
      return actionReducer.updatePlanFail(state, action);

    case actionTypes.POST_PLAN_CONFIG:
      return actionReducer.postPlanConfig(state, action);
    case actionTypes.POST_PLAN_CONFIG_SUCCESS:
      return actionReducer.postPlanConfigSuccess(state, action);
    case actionTypes.POST_PLAN_CONFIG_FAIL:
      return actionReducer.postPlanConfigFail(state, action);

    case actionTypes.EXECUTE_PLAN:
      return actionReducer.executePlan(state, action);
    case actionTypes.EXECUTE_PLAN_SUCCESS:
      return actionReducer.executePlanSuccess(state, action);
    case actionTypes.EXECUTE_PLAN_FAIL:
      return actionReducer.executePlanFail(state, action);

    case actionTypes.GET_ALL_PLANS:
      return actionReducer.getAllPlansList(state, action);
    case actionTypes.GET_ALL_PLANS_SUCCESS:
      return actionReducer.getAllPlansListSuccess(state, action);
    case actionTypes.GET_ALL_PLANS_FAIL:
      return actionReducer.getAllPlansListFail(state, action);

    case actionTypes.RESTORE_PLAN:
      return actionReducer.restorePlan(state, action);
    case actionTypes.RESTORE_PLAN_SUCCESS:
      return actionReducer.restorePlanSuccess(state, action);
    case actionTypes.RESTORE_PLAN_FAIL:
      return actionReducer.restorePlanFail(state, action);

    case actionTypes.RESTORE_DRIVER:
      return actionReducer.restoreDriver(state, action);
    case actionTypes.RESTORE_DRIVER_SUCCESS:
      return actionReducer.restoreDriverSuccess(state, action);
    case actionTypes.RESTORE_DRIVER_FAIL:
      return actionReducer.restoreDriverFail(state, action);

    case actionTypes.GET_FROM_EXTERNAL_SOURCE:
      return actionReducer.getFromExternalSource(state, action);
    case actionTypes.GET_FROM_EXTERNAL_SOURCE_SUCCESS:
      return actionReducer.getFromExternalSourceSuccess(state, action);
    case actionTypes.GET_FROM_EXTERNAL_SOURCE_FAIL:
      return actionReducer.getFromExternalSourceFail(state, action);

    case actionTypes.GET_PLAN_LOGS:
      return actionReducer.getPlanLogs(state, action);
    case actionTypes.GET_PLAN_LOGS_SUCCESS:
      return actionReducer.getPlanLogsSuccess(state, action);
    case actionTypes.GET_PLAN_LOGS_FAIL:
      return actionReducer.getPlanLogsFail(state, action);

    case actionTypes.GET_TOOLNAME_LIST:
      return actionReducer.getToolNameList(state, action);
    case actionTypes.GET_TOOLNAME_LIST_SUCCESS:
      return actionReducer.getToolNameListSuccess(state, action);
    case actionTypes.GET_TOOLNAME_LIST_FAIL:
      return actionReducer.getToolNameListFail(state, action);

    case actionTypes.MISSION_INFO_BY_ORDER_ID:
      return actionReducer.MissionInfoById(state, action);
    case actionTypes.MISSION_INFO_BY_ORDER_ID_SUCCESS:
      return actionReducer.MissionInfoByIdSuccess(state, action);
    case actionTypes.MISSION_INFO_BY_ORDER_ID_FAIL:
      return actionReducer.MissionInfoByIdFail(state, action);

    case actionTypes.DOWNLOAD_PLAN_FORM:
      return actionReducer.downloadPlanForm(state, action);
    case actionTypes.DOWNLOAD_PLAN_FORM_SUCCESS:
      return actionReducer.downloadPlanFormSuccess(state, action);
    case actionTypes.DOWNLOAD_PLAN_FORM_FAIL:
      return actionReducer.downloadPlanFormFail(state, action);

    default:
      return state;
  }
};

export { PlanReducer };
